export default __webpack_public_path__ + "static/media/silvermoon14.e45fc563.jpg";